
    <div class="modal-header bg-light">
        <h4 class="modal-title focus fw-light px-2">Unpublish batch</h4>
	<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <hr>
	<div class="modal-body bg-light"> 
           <p>Customers will no longer be able to view and submit offers against this batch.</p>
            <p>Are you sure you wish to unpublish this batch?</p>
        </div>  
    <hr>
    <div class="modal-footer bg-light">
        <div class="form-group ">
	    <button class="btn btn-light color-black btn-outline-dark mr-2 " type="submit" (click)="activeModal.dismiss('close click')" data-dismiss="modal">Cancel</button>
            <button class="btn btn-danger" type="submit" (click)="unPublish()">Confirm</button> 
     	</div>
    </div>

<!--btn btn-primary-->